export const increasePercentageOverPrevious = (currentValue: number, previousValue: number) => {
	let percentage = ((currentValue - previousValue) / previousValue) * 100 || 0

	if (percentage === Infinity) percentage = 100
	if (percentage === -Infinity) percentage = -100

	return percentage
}
